// FILE END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

if (getLastPart(window.location.href) === 'blog') {
    setTimeout(function(){
        blog_filters();
    }, 50);
}

if ($('#amenity-list').length){
    setTimeout(function(){
        amenity_filters();
    }, 50);
}

});

function getLastPart(url) {
    var parts = url.split("/");
    return (url.lastIndexOf('/') !== url.length - 1 ? parts[parts.length - 1] : parts[parts.length - 2]);
}

function blog_filters() {
    jQuery('.m-filter-results').isotope({
        // options
        itemSelector: '.blog-list-card',
        layoutMode: 'fitRows'
    });
}


function amenity_filters() {
    jQuery('.m-articles').isotope({
        // options
        itemSelector: '.amenity',
        layoutMode: 'fitRows'
    });
}

function amenity_load_more() {
    jQuery('.m-articles').find(".dont-show").removeClass("dont-show");

    setTimeout(function(){
        jQuery('.m-articles').isotope({
            itemSelector: '.amenity',
            layoutMode: 'fitRows'
        });
    }, 100);

}

function create_lead_on_register(dataflow) {
  console.log(dataflow);
  var usrName = jQuery('.m-acc-register').find('input[name="FirstName"]').val();
  var usrSurName = jQuery('.m-acc-register').find('input[name="Surname"]').val();
  var usrEmail = jQuery('.m-acc-register').find('input[name="Email"]').val();
  var usrMobile = jQuery('.m-acc-register').find('input[name="Mobile"]').val();
  var usrPostcode = jQuery('.m-acc-register').find('input[name="Postcode"]').val();
  var usrHowdidyouHear = jQuery('.m-acc-register').find('select[name="HowdidyouHear"]').val();
  var usrHowdidyouHearFix = jQuery('.reg-lead + .selecty').find('.selecty-options .selected').text();
  usrHowdidyouHear = !usrHowdidyouHear.length && usrHowdidyouHearFix.length > 0 ? usrHowdidyouHearFix : usrHowdidyouHear ;
  var usrterms = jQuery('.m-acc-register').find('input[name="cterms"]').val();
  var usrprefEmail = jQuery('.m-acc-register').find('input#cEmail').is(':checked');
  var usrprefPhone = jQuery('.m-acc-register').find('input#cPhone').is(':checked');
  var Source = jQuery('.m-acc-register').find('input[name="custom_source"]').val();

  console.log(usrName);
  console.log(usrSurName);
  console.log(usrEmail);
  console.log(usrMobile);
  console.log(usrPostcode);
  console.log(usrHowdidyouHear);
  console.log(usrterms);
  console.log(usrprefEmail);
  console.log(usrprefPhone);
  console.log(Source);

  var usrPrefComm = typeof usrprefEmail != 'undefined' && usrprefEmail ? 'Email' : 'Phone' ;

  console.log(usrPrefComm);

  var formData = {FirstName:usrName,LastName:usrSurName,Email:usrEmail,MobilePhone:usrMobile,PostalCode:usrPostcode,HowDidYouHearAboutUs:usrHowdidyouHear,AgreeToToSandPP:usrterms, PreferredCommunication: usrPrefComm, Source:Source};


  jQuery('.o-create-account-tipi .button-text').css('opacity', '0');
  jQuery('.o-create-account-tipi .button-loader').show();

  jQuery.ajax({
    url : "/olj-lead",
    type: "POST",
    data : formData,
    success: function(data, textStatus, jqXHR)
    {

      if (data.success){
        jQuery('.o-reserve-process .reservation-step-holder-item').hide('slow');

        if (dataflow == 'booking'){
          jQuery('.o-create-account-tipi .button-text').css('opacity', '1');
          jQuery('.o-create-account-tipi .button-loader').hide();
          var flowObject = JSON.parse(localStorage.getItem('flowObject'));
          jQuery('.book-a-viewing-date').show('slow');
          jQuery('.right-desktop .unit-data-rent').text(flowObject['unitRent']);
          jQuery('.right-desktop .unit-data-bedrooms').text(flowObject['unitBeds']);
          jQuery('.right-desktop .unit-data-size').text(flowObject['unitSize']);
          jQuery('.right-desktop .unit-data-building').text(flowObject['unitBuilding']);
          jQuery('.right-desktop .unit-data-unit-number').text(flowObject['unitNumber']);
          jQuery('.left-desktop .unit-image').css('background-image', 'url(' + flowObject['unitImage'] + ')');
          jQuery('.ui-state-active').click();
        } else if(dataflow == 'reservation') {
          jQuery('.o-reserve-step-one').show('slow');
        }

      } else {
        jQuery('.o-create-account-tipi .m-acc-register').append('<div class="generic-validation">Something went wrong, we were unable to register your account, please contact us at 020 3918 7350<br />Your error code is '+data.code+'</div>');
      }

    },
    error: function (jqXHR, textStatus, errorThrown)
    {

    }
  });
}

// function get_booking_avail_slot(oljdate) {
//
//   jQuery('.timeslot-help-text').hide();
//
//   var formData = {Date:oljdate};
//
//   console.log(formData);
//
//   jQuery('.timeslot-loader').show();
//   jQuery('.slot').removeClass('active-slot');
//   jQuery('.slot').removeClass('hide-slot');
//   jQuery('.slot').css('visibility', 'hidden');
//
//   jQuery.ajax({
//     url : "/olj-slots",
//     type: "POST",
//     data : formData,
//     success: function(data, textStatus, jqXHR)
//     {
//       if (data.success) {
//         console.log(data.slots);
//         jQuery.each(data.slots, function (key, value) {
//           console.log('looping through slots');
//           if (value === false) {
//             console.log('if any slots are false');
//             console.log(key);
//             jQuery('.slot[data-slot="'+key+'"]').addClass('hide-slot');
//           }
//           else {
//             jQuery('.slot[data-slot="'+key+'"]').removeClass('hide-slot');
//           }
//         });
//         jQuery('.book-a-viewing-date .book-a-viewing-info .generic-validation').remove();
//         jQuery('.timeslot-loader').hide();
//         jQuery('.slot').css('visibility', 'visible');
//       }
//       else {
//         jQuery('.book-a-viewing-date .book-a-viewing-info .generic-validation').remove();
//         jQuery('.book-a-viewing-date .book-a-viewing-info').append('<div class="generic-validation">Something went wrong, we were unable to find available slots for your viewing, please contact us at 020 3918 7350<br />Your error code is '+data.code+'</div>');
//       }
//     },
//     error: function (jqXHR, textStatus, errorThrown)
//     {
//
//     }
//   });
//
// }


// function createBooking() {
//   var flowObject = JSON.parse(localStorage.getItem('flowObject'));
//   var unitId = jQuery('.bg-flow').attr('data-unitnide');
//   var viewingDataObject = JSON.parse(localStorage.getItem('viewingDataObject'));
//   var activeSlot = jQuery('.active-slot').attr('data-slot');
//   var bookingDate = viewingDataObject.viewingDate.split(' ');
//   console.log(unitId);
//
//   console.log(bookingDate);
//   console.log(activeSlot);
//   if (typeof activeSlot == 'undefined') {
//     jQuery('.book-a-viewing-date .book-a-viewing-info').append('<div class="generic-validation">Please select a date and time slot to book your viewing.</div>');
//     return;
//   }
//
//   var formData = { Date:bookingDate[2]+'-'+bookingDate[1]+'-'+bookingDate[0], Time:activeSlot, Type:viewingDataObject.viewingPref, Unit:unitId};
//
//   console.log(formData);
//
//   jQuery('.book-a-viewing-date .button-text').css('opacity', '0');
//   jQuery('.book-a-viewing-date .button-loader').show();
//
//   jQuery.ajax({
//     url : "/olj-viewing",
//     type: "POST",
//     data : formData,
//     success: function(data, textStatus, jqXHR)
//     {
//       console.log(data.success);
//       if (data.success){
//         console.log(data.slots);
//         jQuery.each( data.slots, function( key, value ) {
//           console.log(value);
//           if(value === false){
//             console.log('one of them is false');
//             if(jQuery('.slot').attr('data-slot') === key){
//               jQuery(this).hide();
//               console.log(jQuery(this));
//             }
//           }
//         });
//         jQuery('.book-a-viewing-date .button-text').css('opacity', '1');
//         jQuery('.book-a-viewing-date .button-loader').hide();
//         jQuery('.o-reserve-process .reservation-step-holder-item').hide('slow');
//         jQuery('.book-a-viewing-confirmation').show('slow');
//       } else {
//         jQuery('.book-a-viewing-date .book-a-viewing-info').append('<div class="generic-validation">Something went wrong, we were unable to create your viewing, please contact us at 020 3918 7350<br />Your error code is '+data.code+'</div>');
//       }
//
//     },
//     error: function (jqXHR, textStatus, errorThrown)
//     {
//
//     }
//   });
//
// }


// function SaveAccDetails() {
//
//   var FirstName = jQuery('.m-edit-profile').find('input[name="FirstName"]').val();
//   var LastName = jQuery('.m-edit-profile').find('input[name="Surname"]').val();
//   // var Email = jQuery('.m-edit-profile').find('input[name="Email"]').val();
//   var MobilePhone = jQuery('.m-edit-profile').find('input[name="Mobile"]').val();
//   var PreferredCommunication = jQuery('input[name="prefMethod"]:checked').val();
//   var PostalCode = jQuery('.m-edit-profile').find('input[name="Postcode"]').val();
//   var Type  = jQuery('.m-edit-profile').find('input[name="tO"]').val();
//
//   var valid = true;
//
//   var formData = { FirstName:FirstName, LastName:LastName, MobilePhone:MobilePhone, PreferredCommunication:PreferredCommunication, PostalCode:PostalCode, Type:Type };
//
//
//
//   jQuery('.save-profile .button-text').css('opacity', '0');
//   jQuery('.save-profile .button-loader').show();
//
//   jQuery.ajax({
//     url : "/olj-account",
//     type: "POST",
//     data : formData,
//     success: function(data, textStatus, jqXHR)
//     {
//       if (data.success){
//         jQuery('.o-my-account-page .m-acc-register .olj-success-wrapper').remove();
//         console.log('data saved');
//         jQuery('.save-profile .button-text').css('opacity', '1');
//         jQuery('.save-profile .button-loader').hide();
//         jQuery('.o-my-account-page .m-acc-register .generic-validation').remove();
//         jQuery('.o-my-account-page .m-acc-register').prepend('<div class="olj-success-wrapper"><p>Your account has been updated!</p></div>');
//
//       } else {
//         console.log('data could not be saved');
//         jQuery('.save-profile .button-text').css('opacity', '1');
//         jQuery('.save-profile .button-loader').hide();
//         jQuery('.o-my-account-page .m-acc-register .generic-validation').remove();
//         jQuery('.o-my-account-page .m-acc-register').prepend('<div class="generic-validation">Something went wrong, we were unable to update your account, please contact us at 020 3918 7350<br />Your error code is '+data.code+'</div>');
//         jQuery('.o-my-account-page .m-acc-register .olj-success-wrapper').remove();
//       }
//
//     },
//     error: function (jqXHR, textStatus, errorThrown)
//     {
//
//     }
//   });
//
// }


function user_status_check(){
  var login_Status = JSON.parse(localStorage.getItem('loginstatus'));

  if(login_Status == 'no'){

  } else {
    jQuery('.reservation-step-holder-item').hide();
    jQuery.post(
      '/olj-status' ,
      {} ,
      function(data) {
        console.log("Status?")
        console.log(data);
        if (data.success) {
          console.log('I am logged in now');
          if(data.hasLead){
            var flowObject = JSON.parse(localStorage.getItem('flowObject'));
            console.log('I have a lead now');

            if(flowObject['flowType'] == 'reservation') {
              jQuery('.o-reserve-step-one').show();
            } else {
              if(data.hasViewing) {
                jQuery('.o-already-have-booking').show();
              } else {
                jQuery('.book-a-viewing-date').show();
              }
            }
          } else {
            jQuery('.o-create-account-tipi').show();
            console.log('I do not have a lead yet');
          }
        }
        else {
          jQuery('.o-register-with-tipi').show();
        }
      }
    );

  }

}

// function get_ancilliries(){
//   jQuery('.show-step-two .button-text').css('opacity', '0');
//   jQuery('.show-step-two .button-loader').show();
//
//   var flowObject = JSON.parse(localStorage.getItem('flowObject'));
//   var unitId = jQuery('.bg-flow').attr('data-unitnide');
//   var formData = { Unit:unitId };
//
//   jQuery.ajax({
//     url : "/olj-ancillaries",
//     type: "POST",
//     data : formData,
//     success: function(data, textStatus, jqXHR)
//     {
//       console.log(data);
//       if (data.success){
//         jQuery('.show-step-two .button-loader').show();
//         jQuery('.show-step-two .button-text').css('opacity', '0');
//         jQuery('.parking-price').text(data.prices.parking);
//         jQuery('.one-cat-val').attr('data-value' , data.prices.cat);
//         jQuery('.two-cat-val').attr('data-value' , data.prices['2 cats']);
//         jQuery('.one-dog-val').attr('data-value' , data.prices.dog);
//         jQuery('.two-dog-val').attr('data-value' , data.prices['2 dogs']);
//         jQuery('.one-small-value').attr('data-value' , data.prices['small animal']);
//         jQuery('.two-small-value').attr('data-value' , data.prices['2 small animals']);
//         jQuery('.o-reserve-process .reservation-step-holder-item').hide('slow');
//         jQuery('.o-reserve-step-two').show('slow');
//       } else {
//         jQuery('.o-reserve-process .reserve-step-one').append('<div class="generic-validation">Something went wrong, we were unable to continue your reservation, please contact us at 020 3918 7350<br />Your error code is '+data.code+'</div>');
//       }
//
//     },
//     error: function (jqXHR, textStatus, errorThrown)
//     {
//
//     }
//   });
//
// }


// function reserve_unit(){
//   jQuery('.show-res-confirmed .button-text').css('opacity', '0');
//   jQuery('.show-res-confirmed .button-loader').show();
//
//   var Step1Data = JSON.parse(localStorage.getItem('reservationStepOne'));
//   var Step2Data = JSON.parse(localStorage.getItem('reservationStepTwo'));
//   var flowObject = JSON.parse(localStorage.getItem('flowObject'));
//   var Term = Step1Data.leaseTerm.replace(/\D/g,'');
//   console.log(Step1Data.reservationDate);
//   var bookingDate = Step1Data.reservationDate.split(' ');
//
//   var parking;
//   if (Step2Data.selectedParking == 'Parking'){
//     parking = 'true';
//   } else {
//     parking = 'false';
//   }
//
//   var formData = { Unit:flowObject.unitNid, MoveInDate:bookingDate[2]+'-'+bookingDate[1]+'-'+bookingDate[0], Parking:parking, Cats:Step2Data.animalsCat,Dogs:Step2Data.animalsDog,Small:Step2Data.animalsSmall,Term:Term };
//
//
//   console.log(formData);
//
//   jQuery.ajax({
//     url : "/olj-reserve",
//     type: "POST",
//     data : formData,
//     success: function(data, textStatus, jqXHR)
//     {
//       if (data.success){
//         jQuery('.show-res-confirmed .button-loader').show();
//         jQuery('.show-res-confirmed .button-text').css('opacity', '0');
//
//           jQuery('.o-reserve-process .reservation-step-holder-item').hide('slow');
//           jQuery('.o-reservation-confirmed').show('slow');
//       } else {
//         jQuery('<div class="generic-validation">Something went wrong, we were unable to complete your reservation, please contact us at 020 3918 7350<br />Your error code is '+data.code+'</div>').insertBefore(jQuery('.o-reserve-process .pay-reserve.show-res-confirmed'));
//       }
//
//     },
//     error: function (jqXHR, textStatus, errorThrown)
//     {
//
//     }
//   });
//
// }

// function validate_acc_edit() {
//   var valid = true;
//   if(jQuery('.m-edit-profile .reg-postcode').val() === ""){
//     jQuery('.m-edit-profile .reg-postcode').addClass('needs-val');
//     valid = false;
//   } else {
//     // jQuery('.reg-postcode').removeClass('needs-val');
//     if (jQuery('.m-edit-profile .reg-postcode').val().replace(' ','').match(/^[0-9a-zA-Z]+$/) == null) {
//       jQuery('.m-edit-profile .reg-postcode').addClass('needs-val');
//       valid = false;
//     }
//     else {
//       jQuery('.m-edit-profile .reg-postcode').removeClass('needs-val');
//     }
//   }
//
//   if(!valid) {
//     jQuery('.m-edit-profile .form-not-validated').show();
//     return false;
//
//   } else {
//     jQuery('.m-edit-profile .form-not-validated').hide();
//     return true;
//
//   }
// }

function validateEmail($email) {
  var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
  return emailReg.test( $email );
  console.log('why not');
}

function validate_acc_creation_popup() {
  // var usrName = jQuery('.m-acc-register').find('input[name="FirstName"]');
  // var usrSurName = jQuery('.m-acc-register').find('input[name="Surname"]');
  // var usrEmail = jQuery('.m-acc-register').find('input[name="Email"]');
  // var usrMobile = jQuery('.m-acc-register').find('input[name="Mobile"]');
  // var usrPostcode = jQuery('.m-acc-register').find('input[name="Postcode"]');
  var usrHowdidyouHear = jQuery('.m-acc-register').find('select[name="HowdidyouHear"]').val();
  var usrHowdidyouHearFix = jQuery('.reg-lead + .selecty').find('.selecty-options .selected').text();
  var usrterms = jQuery('.m-acc-register').find('input[name="cterms"]');
  // var usrpref = jQuery('.m-acc-register').find('input[name="prefMethod"]');

  console.log(usrHowdidyouHear);
  console.log(usrHowdidyouHearFix);

  var valid = true;

  if (!usrterms.is(':checked')) {
    jQuery('#cterms + .checkmark').addClass('needs-val');
    valid = false;
  } else {
    jQuery('#cterms + .checkmark').removeClass('needs-val');
  }

  if(jQuery('.reg-fname').val() === ""){
    jQuery('.reg-fname').addClass('needs-val');
    valid = false;
  } else {
    jQuery('.reg-fname').removeClass('needs-val');
  }

  if(jQuery('.reg-surname').val() === ""){
    jQuery('.reg-surname').addClass('needs-val');
    valid = false;
  } else {
    jQuery('.reg-surname').removeClass('needs-val');
  }

  if(jQuery('.reg-email').val() === ""){
    jQuery('.reg-email').addClass('needs-val');
    valid = false;
  } else {
    jQuery('.reg-email').removeClass('needs-val');
  }

  if (!isEmail(jQuery('.reg-email').val())){
    jQuery('.reg-email').addClass('needs-val');
    valid = false;
  } else {
    jQuery('.reg-email').removeClass('needs-val');
  }

  if(jQuery('.reg-mobile').val() === ""){
    jQuery('.reg-mobile').addClass('needs-val');
    valid = false;
  } else {
    if (jQuery('.reg-mobile').val() == jQuery('.reg-mobile').attr('data-code')) {
      jQuery('.reg-mobile').addClass('needs-val');
      valid = false;
    }
    else {
      if (jQuery('.reg-mobile').val().length < 8) {
        jQuery('.reg-mobile').addClass('needs-val');
        valid = false;
      }
      jQuery('.reg-mobile').removeClass('needs-val');
    }
  }

  console.log(usrHowdidyouHear.length);
  console.log(usrHowdidyouHear.length == 0);
  console.log(usrHowdidyouHearFix.length);
  console.log(usrHowdidyouHearFix.length == 0);
  console.log(usrHowdidyouHear.length == 0 && usrHowdidyouHearFix.length == 0);

  if(usrHowdidyouHear.length == 0 && usrHowdidyouHearFix.length == 0){
    jQuery('.selecty-selected').addClass('needs-val');
    valid = false;
  } else {
    jQuery('.selecty-selected').removeClass('needs-val');
  }

  if(jQuery('.reg-postcode').val() === ""){
    jQuery('.reg-postcode').addClass('needs-val');
    valid = false;
  } else {
    // jQuery('.reg-postcode').removeClass('needs-val');
    if (jQuery('.reg-postcode').val().replace(' ','').match(/^[0-9a-zA-Z]+$/) == null) {
      jQuery('.reg-postcode').addClass('needs-val');
      valid = false;
    }
    else {
      jQuery('.reg-postcode').removeClass('needs-val');
    }
  }


  if(!valid) {
    jQuery('.form-not-validated').show();
    return false;

  } else {
    jQuery('.form-not-validated').hide();
    return true;

  }

}


function isEmail(email) {
  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
}


function validate_booking_terms() {
  var valid = true;
  var usrterms = jQuery('.agree-reservation-fee').find('input[name="termsc"]');
  if (!usrterms.is(':checked')) {
    jQuery('#termsc + .checkmark').addClass('needs-val');
    valid = false;
  } else {
    jQuery('#termsc + .checkmark').removeClass('needs-val');
  }
  if(!valid) {
    jQuery('.form-not-validated').show();
    return false;

  } else {
    jQuery('.form-not-validated').hide();
    return true;

  }
}

